module.exports = __webpack_public_path__ + "img/Gemeindezeltlager(1).723dc750.jpg";